import React from 'react';
import { motion } from 'framer-motion';

const ReturnsPage = () => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }} className="min-h-screen bg-deepDark pt-20 pb-32">
      <div className="max-w-4xl mx-auto px-4">
        
        <div className="text-center mb-20">
          <p className="text-gold text-[10px] tracking-widest uppercase mb-4">Client Satisfaction</p>
          <h1 className="text-5xl md:text-6xl font-serif text-white tracking-wide mb-8">Returns & Exchanges</h1>
          <div className="w-16 h-[1px] bg-gold mx-auto"></div>
        </div>

        <div className="prose prose-invert prose-lg mx-auto font-light leading-relaxed text-textMuted">
          <p>
            We are confident in the unparalleled quality of our high jewelry. However, if an acquisition does not entirely meet your expectations, we offer a discrete and seamless return process.
          </p>

          <h2 className="text-white font-serif mt-12 mb-6">Standard 14-Day Protocol</h2>
          <p>
            Items in their pristine, unworn condition with all original packaging, diamond certificates, and tags attached may be returned for a full refund within 14 days of receipt. Our concierge will arrange for a secure, insured courier collection from your residence or office at no charge to you.
          </p>

          <h2 className="text-white font-serif mt-12 mb-6">Bespoke & Engraved Pieces</h2>
          <p>
            Please note that pieces which have been fundamentally altered, custom commissioned, or personally engraved are exempt from our standard return policy due to their individualized nature. These transactions are considered final.
          </p>

          <h2 className="text-white font-serif mt-12 mb-6">Initiating a Return</h2>
          <ol className="list-decimal pl-6 space-y-4">
            <li>Contact your dedicated concierge or email <span className="text-gold">concierge@luxejewels.com</span>.</li>
            <li>Receive your secure RMA (Return Merchandise Authorization) documentation and secure transit seals.</li>
            <li>Pack the item exactly as instructed within the provided tamper-evident manifest bags.</li>
            <li>Hand the package to our dispatched armored courier at the arranged time.</li>
          </ol>

          <p className="mt-12 text-sm italic text-white/50 border-t border-white/10 pt-8">
            Refunds will be processed to the original payment method exclusively after our gemological division authenticates the returned piece, typically within 72 hours of its arrival back at our vaults.
          </p>
        </div>

      </div>
    </motion.div>
  );
};

export default ReturnsPage;
